import styled, { css } from 'styled-components';

export const ImageAttachment = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export default css`
  padding: 0;
  height: 100px;
  overflow: auto;
  flex-grow: 1;

  div.attachment {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    padding: 4px 0;

    &.is-loading {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;
